import {Typography} from 'components/Typography';
import React, {FC} from 'react';
import style from './style.module.scss';
import {IExpressOrder} from 'plugins/modules/filter/types';
import {useWineshopWarningText} from 'plugins/modules/filter/components/ExpressOrder/hooks/useWineshopWarningText';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';
import cs from 'classnames';

interface IProps {
    wineShop: IExpressOrder;
}

export const WineryWorkingHours: FC<IProps> = ({wineShop}) => {
    const warningText = useWineshopWarningText(wineShop);
    const {isActive: isAbExpressOrder} = useGetAbExpressOrder();

    if (!warningText) {
        return null;
    }

    return (
        <div className={cs(style.main, {[style.new]: isAbExpressOrder})}>
            <Typography variant={'label-12-r'}>{warningText}</Typography>
        </div>
    );
};
